//(function () {
//	'use strict';

//	const module = angular.module('imApp');

//	module.component('categoryLinkAdd', {
//		templateUrl: 'views/components/views/categoryLinkAdd/categoryLinkAdd.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'categoryLinkAddService', 'categoryLinksService', function ($stateParams, stateService, categoryLinkAddService, categoryLinksService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let categoryKeynoBelongTo = $stateParams.category_keyno_belongto;

//			vm.model = {
//                categoryNameButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.category_name_new = '' },
//                    { id: 'new', icon: 'fa fa-solid fa-plus', color: 'success', type: 'success', onClick: () => addLink() }
//                ],
//                setting: {
//                    category_name_new: ''
//                },
//                itemsListNotLinked: []
//			};

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadBelongTo() {
//                vm.model.setting = (await categoryLinksService.getBelongTo({ category_keyno: categoryKeynoBelongTo }))[0];
//			}

//            async function loadNotLinked() {
//                vm.model.itemsListNotLinked = (await categoryLinkAddService.listNotLinked({ category_keyno_belongto: categoryKeynoBelongTo }));
//			}

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region SAVE FUNCTIONS

//            function addLink() {
//                categoryLinkAddService.saveLink({
//                    category_keyno: 0,
//                    category_keyno_belongto: categoryKeynoBelongTo,
//                    category_name: vm.model.setting.category_name_new
//                }).then(function () {
//                    stateService.back();
//                });
//            }

//			vm.linkItem = function (item) {
//                categoryLinkAddService.saveLink({
//                    category_keyno: item.item_id,
//                    category_keyno_belongto: categoryKeynoBelongTo,
//                    category_name: ''
//                }).then(function () {
//					stateService.back();
//				});
//            }

//            // #endregion SAVE FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadBelongTo();
//                loadNotLinked();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
